import { LoginFunction } from 'components/providers/loginContext';
import { ENDPOINT_LOGS } from 'constants/constants';
import { getAPI } from 'utils/commonService';

type LogStatus = 'accepted' | 'processing' | 'completed' | 'error' | 'canceled';

export type Log = {
  id: string;
  executeKey: string;
  executeAtUTCKey: string; // 連携 Md 実行開始日時
  executeEndAtUTC: string; // 連携 Md 実行終了日時
  tenantId: string;
  wfId: number;
  serviceClass: string;
  status: LogStatus;
  message?: string;
  jobId?: number;
  errorMessageId?: string;
  errorMessage?: string;
};

// 指定したWFアプリの実行ジョブのログを取得する
export async function getLogs(
  wfId: number,
  page: number,
  itemsPerPage: number,
  loginContext: LoginFunction,
): Promise<Log[]> {
  const params = { wfId, page, itemsPerPage };
  return (await getAPI(ENDPOINT_LOGS, loginContext, params)) as Log[];
}
